const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * ASKI SOAP servisinden AboneParklar verisini Lambda proxy uzerinden ceker.
 * ONEMLI: Bu fonksiyon sadece kullanici aksiyonu ile tetiklenmeli,
 * otomatik/periyodik cagri yapilmamali.
 */
export const fetchAboneParklar = async () => {
  if (!API_BASE_URL) {
    throw new Error('Backend API endpoint tanımlı değil. Lütfen .env.local dosyasına REACT_APP_API_BASE_URL ekleyin.');
  }

  const response = await fetch(`${API_BASE_URL}/api/aski/aboneparklar`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const text = await response.text();
    console.error('ASKI API JSON donmedi:', text.substring(0, 200));
    throw new Error('Backend API çalışmıyor veya ASKI endpoint bulunamadı.');
  }

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || `HTTP ${response.status}: ${response.statusText}`);
  }

  return result;
};

export const fetchHistory = async () => {
  if (!API_BASE_URL) throw new Error('Backend API endpoint tanımlı değil.');
  const response = await fetch(`${API_BASE_URL}/api/aski/history`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const fetchHistoryItem = async (key) => {
  if (!API_BASE_URL) throw new Error('Backend API endpoint tanımlı değil.');
  const response = await fetch(`${API_BASE_URL}/api/aski/history/get?key=${encodeURIComponent(key)}`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  const result = await response.json();
  if (result.presignedUrl) {
    const s3Response = await fetch(result.presignedUrl);
    if (!s3Response.ok) throw new Error(`S3 download failed: ${s3Response.status}`);
    return s3Response.json();
  }
  return result;
};

export const fetchDbStatus = async () => {
  if (!API_BASE_URL) throw new Error('Backend API endpoint tanımlı değil.');
  const response = await fetch(`${API_BASE_URL}/api/aski/db-status`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const askiService = {
  fetchAboneParklar,
  fetchHistory,
  fetchHistoryItem,
  fetchDbStatus,
};
